import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { filter, first, forkJoin, Observable, tap } from 'rxjs';
import { LayoutService } from '../services/layout.service';
import { MetaService } from '../services/meta.service';
import { PageResolverResopnse } from '../types/page-resolver-response.type';
import { GlobalService } from '../../common/services/global.service';

export const homePageLayoutResolver: ResolveFn<any> = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
): Observable<any> => {
    const metaService = inject(MetaService);
    const globalService = inject(GlobalService);
    return forkJoin({
        pageDataResponse: inject(LayoutService).getHomePageLayout(),
        companyDetails: globalService.companyDetails.pipe(
            filter(details => details !== null),
            first()
        )
    }).pipe(
        tap((response) => {
            metaService.updateHomePageMetaTags(response?.pageDataResponse.body?.data.page);
        }),
    );
};
